/* eslint-disable relay/unused-fields */
import first from "lodash/first";
import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "scmp-app/components/article/article-render";
import type { landingBannerInfographicArticle$key } from "scmp-app/queries/__generated__/landingBannerInfographicArticle.graphql";

import {
  Container,
  Content,
  Headline,
  Section,
  StyledArticleShareWidget,
  StyledFigcaption,
  StyledFigure,
  StyledImage,
} from "./styles";

type Props = {
  className?: string;
  provider: DefaultComponentsProvider;
  reference: landingBannerInfographicArticle$key;
};

export const LandingBannerInfographic: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  provider,
  ref,
  reference,
}) => {
  const article = useFragment(
    graphql`
      fragment landingBannerInfographicArticle on Article {
        ...articleSponsorContent
        ...articleShareWidgetArticle
        headline
        topics {
          ...entityLink
          name
        }
        images {
          title
          url
        }
        coverHero: image(filter: { type: HERO }) {
          url
        }
      }
    `,
    reference,
  );

  const coverImage = first(article.images);
  const imageUrl = article.coverHero?.url ?? coverImage?.url;

  return (
    <Container className={className} ref={ref}>
      <Content>
        <Section>{provider.sections({ variant: "infographic" })}</Section>
        <Headline>{article.headline}</Headline>
        <StyledArticleShareWidget reference={article} variant="legacyShare" />
      </Content>

      <StyledFigure>
        <StyledImage alt={coverImage?.title ?? ""} src={imageUrl} />
        {coverImage?.title && <StyledFigcaption>{coverImage?.title}</StyledFigcaption>}
      </StyledFigure>
    </Container>
  );
};

LandingBannerInfographic.displayName = "LandingBannerInfographic";
